import {
  RenderSelectInput,
  RenderTextArea,
  RenderTextInput,
} from "app/common/renderInput";
import { updatePnr } from "app/services/bookingService";
import { Formik } from "formik";
import moment from "moment";
import { memo, useEffect, useState } from "react";
import { Button, Card, Col, Image, Modal, Row } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import countryData from "../../Flight/PNR/countryCode.json";
import { validationModel } from "./PnrModel";

import { getBookingDetails } from "app/services/AdminServices/bookingService";
import Tooltip from "rc-tooltip";
import {
  FaLongArrowAltRight,
  FaPlaneArrival,
  FaPlaneDeparture,
} from "react-icons/fa";
import { MdOutlineLocationOn } from "react-icons/md";
const PnrAlert = ({ show, handleClose, response, loadBookingDetails }) => {
  // console.log(response);

  const [formState, setFormState] = useState(response);
  const [statusTypeOptions] = useState([
    { value: "PENDING", label: "PENDING" },
    { value: "COMPLETED", label: "COMPLETED" },
    { value: "CANCELLED", label: "CANCELLED" },
    { value: "REJECTED", label: "REJECTED" },
    { value: "BLOCKED", label: "BLOCKED" },
  ]);
  const [country, setCountry] = useState(countryData);
  // console.log(country);
  const [paxTypeOptions] = useState([
    { value: "Adult", label: "Adult" },
    { value: "Child", label: "Child" },
    { value: "Infant", label: "Infant" },
  ]);
  const [refundOptions] = useState([
    { value: "REFUNDABLE", label: "REFUNDABLE" },
    { value: "NON REFUNDABLE", label: "NON REFUNDABLE" },
    { value: "PARTIAL REFUNDABLE", label: "PARTIAL REFUNDABLE" },
  ]);
  const [titleOptions] = useState([
    { value: "Mr", label: "Mr" },
    { value: "Ms", label: "Ms" },
    { value: "Mrs", label: "Mrs" },
    { value: "Master", label: "Master" },
  ]);
  const [fareType, setFareType] = useState(null);
  // const [data, setData] = useState(null);
  // const [fareQuote, setFareQuote] = useState(null);
  const [review, setReview] = useState(null);
  const [baseFare, setBaseFare] = useState(null);
  const [TotalFare, setTotalFare] = useState(null);
  const [netFare, setNetFare] = useState(null);
  const [taxFare, setTaxFare] = useState(null);
  const [airlinesMarkupComOnward, setAirlinesMarkupComOnward] = useState(0);
  // const [airlinesMarkupComReturn, setAirlinesMarkupComReturn] = useState(0);
  const [tdsOnward, setTdsOnward] = useState(0);
  // const [tdsReturn, setTdsReturn] = useState(0);
  const [ssrOnward, setSsrOnward] = useState(0);
  // const [ssrReturn, setSsrReturn] = useState(0);
  const [userMarkup, setUserMarkup] = useState(0);
  useEffect(() => {
    if (response && response.passengerList) {
      const passDetails = response?.passengerList?.map((pass, i) => {
        return {
          passengerId: pass.id,
          ti: pass.title,
          fN: pass.firstName,
          lN: pass.lastName,
          pt: pass.passengerType,
          dob: pass.birthDate,
          pNum: pass.passport,
          eD: pass.passportExpiryDate,
          pid: pass.passportIssueDate,
          pNat: pass.passportNationality,
          isDomestic: response.isDomestic,
          ticketNo: pass.ticketNo,
          passengerPnr: pass.pnr,
          baggageAlloweance: pass.baggageAlloweance,
          mealAllowance: pass.mealAllowance,
        };
      });

      const requiredFormat = {
        totalBF: parseFloat(baseFare).toFixed(2),
        totalTF: parseFloat(TotalFare).toFixed(2),
        totalTAF: parseFloat(taxFare).toFixed(2),
        totalNF: parseFloat(netFare).toFixed(2),
        id: response.id,
        bookingId: response.bookingId,
        pnr: response.pnr,
        bookingStatus: response.currentStatus,
        baggageAllowance: response.baggageAllowance,
        mealAllowance: response.mealAllowance,
        remarks: response.remarks,
        refundStatus: response.refundStatus,
        travellerInfo: [...passDetails],
        coRelationId: response.coRelationId,
      };

      setFormState(requiredFormat);
    }
  }, [review]);

  const bookingData = async (value) => {
    setReview(null);

    const response = await getBookingDetails(value?.id);
    const responseCorrelationId = await getBookingDetails(value?.coRelationId);
    // console.log(responseCorrelationId.data.data);
    const reviewRes = JSON.parse(response.data.data.reviewApiResponse);
    console.log(reviewRes, "reviewRes");
    setReview(reviewRes);
    if (responseCorrelationId.data.data.length == 1) {
      ///Onward tdsAmount
      const userMarkupOnward =
        responseCorrelationId?.data?.data[0]?.userMarkupAmount ?? 0;

      const gateway = responseCorrelationId.data.data[0]?.apiGateway.trim(); //TRIPJACK

      const airlinesMarkupOnward =
        responseCorrelationId?.data?.data[0]?.totalCarrierServiceCharges ?? 0;

      const tdsOnward = responseCorrelationId?.data?.data[0]?.tdsAmount ?? 0;

      const ssrAmountOnward =
        responseCorrelationId?.data?.data[0]?.onewaySSRAmount ?? 0;

      const totalFare =
        reviewRes?.totalPriceInfo?.totalFareDetail?.fC?.TF +
        ssrAmountOnward +
        userMarkupOnward;
      const netFareTJ =
        reviewRes?.totalPriceInfo?.totalFareDetail?.fC?.NF + ssrAmountOnward;
      const netFareRestApi =
        reviewRes?.totalPriceInfo?.totalFareDetail?.fC?.NF +
        ssrAmountOnward -
        airlinesMarkupOnward +
        tdsOnward;

      const tds =
        gateway == "TRIPJACK"
          ? reviewRes.totalPriceInfo?.totalFareDetail?.afC?.NCM?.TDS
          : tdsOnward;
      const markup =
        gateway == "TRIPJACK"
          ? reviewRes.totalPriceInfo?.totalFareDetail?.afC?.NCM?.OT
          : airlinesMarkupOnward;
      setAirlinesMarkupComOnward(markup);
      setTdsOnward(tds);
      setSsrOnward(ssrAmountOnward);
      setUserMarkup(userMarkupOnward);
      setBaseFare(reviewRes?.totalPriceInfo?.totalFareDetail?.fC?.BF);
      setTotalFare(totalFare);
      setNetFare(gateway == "TRIPJACK" ? netFareTJ : netFareRestApi);
      setTaxFare(reviewRes?.totalPriceInfo?.totalFareDetail?.fC?.TAF);
      setFareType(reviewRes?.tripInfos[0]?.totalPriceList[0]);
    } else {
      ///Onward

      const userMarkupOnward =
        responseCorrelationId?.data?.data[0]?.userMarkupAmount ?? 0;
      const gateway = responseCorrelationId.data.data[0]?.apiGateway.trim(); //TRIPJACK

      const airlinesMarkupOnward =
        responseCorrelationId?.data?.data[0]?.totalCarrierServiceCharges ?? 0;

      const tdsOnward = responseCorrelationId?.data?.data[0]?.tdsAmount ?? 0;

      const ssrAmountOnward =
        responseCorrelationId?.data?.data[0]?.onewaySSRAmount ?? 0;
      ///Return
      const userMarkupReturn =
        responseCorrelationId?.data?.data[1]?.userMarkupAmount ?? 0;
      const airlinesMarkupReturn =
        responseCorrelationId?.data?.data[1]?.totalCarrierServiceCharges ?? 0;

      const tdsReturn = responseCorrelationId?.data?.data[1]?.tdsAmount ?? 0;

      const ssrAmountReturn =
        responseCorrelationId?.data?.data[1]?.onewaySSRAmount > 0
          ? responseCorrelationId?.data?.data[1]?.onewaySSRAmount
          : responseCorrelationId?.data?.data[1]?.returnSSRAmount ?? 0;
      const netFareTJ =
        reviewRes?.totalPriceInfo?.totalFareDetail?.fC?.NF +
        ssrAmountOnward +
        ssrAmountReturn;
      const netFareRestApi =
        reviewRes?.totalPriceInfo?.totalFareDetail?.fC?.NF +
        (ssrAmountOnward + ssrAmountReturn) +
        (tdsOnward + tdsReturn) -
        (airlinesMarkupOnward + airlinesMarkupReturn);
      const totalFare =
        reviewRes?.totalPriceInfo?.totalFareDetail?.fC?.TF +
        ssrAmountOnward +
        ssrAmountReturn +
        userMarkupOnward +
        userMarkupReturn;
      const tds =
        gateway == "TRIPJACK"
          ? reviewRes.totalPriceInfo?.totalFareDetail?.afC?.NCM?.TDS
          : tdsOnward + tdsReturn;
      const markup =
        gateway == "TRIPJACK"
          ? reviewRes.totalPriceInfo?.totalFareDetail?.afC?.NCM?.OT
          : airlinesMarkupOnward + airlinesMarkupReturn;

      setAirlinesMarkupComOnward(markup);
      setTdsOnward(tds);
      setSsrOnward(ssrAmountOnward + ssrAmountReturn);
      setUserMarkup(userMarkupOnward + userMarkupReturn);
      setBaseFare(reviewRes?.totalPriceInfo?.totalFareDetail?.fC?.BF);
      setTotalFare(totalFare);
      setNetFare(gateway == "TRIPJACK" ? netFareTJ : netFareRestApi);
      setTaxFare(reviewRes?.totalPriceInfo?.totalFareDetail?.fC?.TAF);
      setFareType(reviewRes?.tripInfos[0]?.totalPriceList[0]);
    }

    // console.log(response.data.data);
  };
  useEffect(() => {
    if (response?.length > 0) {
      bookingData(response);
    }
  }, [response]);
  const airlinesPnr = (value, paxPnr) => {
    const codePnr = `${value.da.code}-${value.aa.code}`;
    const model = {
      [codePnr]: paxPnr.passengerPnr,
    };

    return model;
  };
  const globalAirlinesPnr = (value, pnr) => {
    const codePnr = `${value.da.code}-${value.aa.code}`;
    const model = {
      [codePnr]: pnr.pnr,
    };

    return model;
  };
  const globalPnrDetails = (values) => {
    let pnr = {};
    review.tripInfos.map((seg, id) => {
      seg.sI.map((seg, id) => {
        let res = globalAirlinesPnr(seg, values);
        pnr = Object.keys(pnr).length > 0 ? { ...pnr, ...res } : { ...res };
      });
    });
    return pnr;
  };
  const pnrDetails = (paxPnr) => {
    let pnr = {};
    review.tripInfos.map((seg, id) => {
      seg.sI.map((seg, id) => {
        let res = airlinesPnr(seg, paxPnr);
        pnr = Object.keys(pnr).length > 0 ? { ...pnr, ...res } : { ...res };
      });
    });
    return pnr;
  };
  const airlinesTicketNo = (value, no) => {
    const codePnr = `${value.da.code}-${value.aa.code}`;
    const model = {
      [codePnr]: no.ticketNo,
    };

    return model;
  };
  const ticketNoInfo = (item, value) => {
    let ticketNo = {};
    value[0].sI.map((seg, i) => {
      let res = airlinesTicketNo(seg, item);
      ticketNo =
        Object.keys(ticketNo).length > 0 ? { ...ticketNo, ...res } : { ...res };
    });
    return ticketNo;
  };

  const ticketNoInfoReturn = (item, value) => {
    let ticketNo = {};

    value[1]?.sI?.map((seg, i) => {
      let res = airlinesTicketNo(seg, item);
      ticketNo =
        Object.keys(ticketNo).length > 0 ? { ...ticketNo, ...res } : { ...res };
    });
    return ticketNo;
  };
  const pnrsGds = (value, paxGds) => {
    const codePnr = `${value.da.code}-${value.aa.code}`;
    const model = {
      [codePnr]: paxGds.gdsPnrs,
    };

    return model;
  };
  const gds = (paxGds) => {
    let pnrGds = {};
    review.tripInfos.map((seg, id) => {
      seg.sI.map((seg, id) => {
        let res = pnrsGds(seg, paxGds);
        pnrGds =
          Object.keys(pnrGds).length > 0 ? { ...pnrGds, ...res } : { ...res };
      });
    });
    return pnrGds;
  };
  const handleSubmit = async (values) => {
    const onwardPax = await Promise.all(
      values.travellerInfo.map(async (seg, id) => {
        const resTicketNo = ticketNoInfo(seg, review.tripInfos);
        return {
          ticketNumberDetails: resTicketNo,
        };
      })
    );
    // console.log(onwardPax, "onwardPax");

    const returnPax = await Promise.all(
      values.travellerInfo.map(async (seg, id) => {
        const resTicketNo = ticketNoInfoReturn(seg, review.tripInfos);
        return {
          ticketNumberDetails: resTicketNo,
        };
      })
    );

    let pnrModel = {
      order: {
        bookingId: values.bookingId,
        amount: Number(values.totalNF),
        markup: 0,
        orderType: "AIR",
        // deliveryInfo,
        status: "SUCCESS",
        createdOn: moment().format(),
      },
      itemInfos: {
        AIR: {
          tripInfos: review.tripInfos,
          travellerInfos: await Promise.all(
            values.travellerInfo.map(async (seg, id) => {
              const mergedDetails = {};
              // // Merge details from "onwardPax"
              Object.assign(mergedDetails, onwardPax[id].ticketNumberDetails);

              Object.assign(mergedDetails, returnPax[id]?.ticketNumberDetails);

              return {
                ticketNumberDetails: seg.gdsPnrs == null ? "" : mergedDetails,
                pnrDetails: pnrDetails(seg),
                gdsPnrs: seg.gdsPnrs == null ? "" : gds(seg),
                ti: seg.ti,
                pt: seg.pt,
                fN: seg.fN,
                lN: seg.lN,
                dob: seg.dob,
                pNum: seg.pNum,
                eD: seg.eD,
                pid: seg.pid,
                id: id + 1,
                pNat: values.flightType == "Domestic" ? "" : seg.pNat,
              };
            })
          ),
          totalPriceInfo: {
            totalFareDetail: {
              fC: {
                NF: netFare - ssrOnward,
                BF: Number(values.totalBF),
                TAF: Number(values.totalTAF),
                TF: Number(values.totalTF),
              },
              afC: {
                NCM: {
                  OT: airlinesMarkupComOnward,
                  TDS: -tdsOnward,
                },
              },
            },
          },
        },
      },

      gstInfo: {},
      status: {},
    };

    let reviewModel = {
      ...review,
      totalPriceInfo: {
        totalFareDetail: {
          fC: {
            ...review.totalPriceInfo.totalFareDetail.fC,
            NF: netFare - ssrOnward,
            // TotalFare -
            // // review.totalPriceInfo.totalFareDetail.fC.TF -
            // airlinesMarkupComOnward +
            // tdsOnward,
          },
          afC: {
            NCM: {
              OT: airlinesMarkupComOnward,
              TDS: -tdsOnward,
            },
          },
        },
      },
    };
    // console.log(reviewModel, "reviewModel");
    const updatePnrReq = {
      id: values.id,
      bookingId: values.bookingId,
      // pnr: globalPnrDetails(values),
      pnr: values.pnr,
      coRelationId: values.coRelationId,
      bookingStatus: values.bookingStatus,
      bookingApiResponse: JSON.stringify(pnrModel),
      reviewApiResponse: JSON.stringify(reviewModel),
      travellerInfo: values.travellerInfo.map((seg, id) => {
        return {
          passengerId: seg.passengerId,
          ti: seg.ti,
          fN: seg.fN,
          lN: seg.lN,
          pt: seg.pt,
          dob: seg.dob,
          pNum: seg.pNum,
          eD: seg.eD,
          pid: seg.pid,
          pNat: seg.pNat,
          ticketNo: seg.ticketNo,
          passengerPnr: seg.passengerPnr,
        };
      }),
    };
    console.log(updatePnrReq);
    const updateResponse = await updatePnr(updatePnrReq);

    if (updateResponse.status == "Success") {
      NotificationManager.success(updateResponse.message, "Success", 5000);
      handleClose();
      loadBookingDetails();
    } else {
      NotificationManager.error(updateResponse.message, "error", 5000);
    }
  };
  const getTimeDiffFromDate = (startDate, endDate) => {
    //   const getTimeDiffFromDate(startDate, endDate) {
    const dateFuture = new Date(startDate);
    const dateNow = new Date(endDate);

    let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;

    // calculate days
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;
    //console.log('calculated days', days);

    // calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;
    //console.log('calculated hours', hours);

    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;
    //console.log('minutes', minutes);

    let difference = "";
    if (days > 0) {
      difference += days === 1 ? `${days} d, ` : `${days} d, `;
    }

    difference += hours === 0 || hours === 1 ? `${hours} h, ` : `${hours} h, `;

    difference +=
      minutes === 0 || hours === 1 ? `${minutes} m` : `${minutes} m`;

    return difference;
  };
  const convertIntoHr = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const formattedTime = `${hours}h ${minutes}m`;

    // console.log(formattedTime);
    return formattedTime;
  };
  return (
    <Modal show={show} size="xl" scrollable={true} onHide={handleClose}>
      <Modal.Header
        className="text-primary"
        style={{ fontSize: "20px", fontWeight: "bold" }}
        closeButton
      >
        Update PNR
      </Modal.Header>

      <Modal.Body>
        <>
          <div
            style={{ maxHeight: 350, overflowY: "scroll", marginBottom: 20 }}
          >
            {review?.tripInfos.map((res, index) => (
              <>
                <Card style={{ marginTop: index == 1 && 5, marginBottom: 10 }}>
                  {index == 0 ? (
                    <Card.Header as="h5">
                      <Tooltip
                        placement="top"
                        overlay={
                          <div style={{ maxWidth: "auto" }}>
                            {
                              review?.searchQuery?.routeInfos[0]
                                ?.fromCityOrAirport?.name
                            }
                          </div>
                        }
                      >
                        <span style={{ cursor: "pointer" }}>
                          {
                            review?.searchQuery?.routeInfos[0]
                              ?.fromCityOrAirport?.city
                          }{" "}
                        </span>
                      </Tooltip>
                      <FaLongArrowAltRight />{" "}
                      <Tooltip
                        placement="top"
                        overlay={
                          <div style={{ maxWidth: "auto" }}>
                            {
                              review?.searchQuery?.routeInfos[0]
                                ?.toCityOrAirport?.name
                            }
                          </div>
                        }
                      >
                        <span style={{ cursor: "pointer" }}>
                          {
                            review?.searchQuery?.routeInfos[0]?.toCityOrAirport
                              ?.city
                          }{" "}
                        </span>
                      </Tooltip>{" "}
                      <span style={{ color: "GrayText" }}>
                        on{" "}
                        {moment(
                          review?.searchQuery?.routeInfos[0]?.travelDate
                        ).format("ddd, MMM Do, YYYY")}
                      </span>
                    </Card.Header>
                  ) : (
                    <Card.Header as="h5">
                      <Tooltip
                        placement="top"
                        overlay={
                          <div style={{ maxWidth: "auto" }}>
                            {
                              review?.searchQuery?.routeInfos[1]
                                ?.fromCityOrAirport?.name
                            }
                          </div>
                        }
                      >
                        <span style={{ cursor: "pointer" }}>
                          {
                            review?.searchQuery?.routeInfos[1]
                              ?.fromCityOrAirport?.city
                          }{" "}
                        </span>
                      </Tooltip>
                      <FaLongArrowAltRight />{" "}
                      <Tooltip
                        placement="top"
                        overlay={
                          <div style={{ maxWidth: "auto" }}>
                            {
                              review?.searchQuery?.routeInfos[1]
                                ?.toCityOrAirport?.name
                            }
                          </div>
                        }
                      >
                        <span style={{ cursor: "pointer" }}>
                          {
                            review?.searchQuery?.routeInfos[1]?.toCityOrAirport
                              ?.city
                          }{" "}
                        </span>
                      </Tooltip>{" "}
                      <span style={{ color: "GrayText" }}>
                        on{" "}
                        {moment(
                          review?.searchQuery?.routeInfos[1]?.travelDate
                        ).format("ddd, MMM Do, YYYY")}
                      </span>
                    </Card.Header>
                  )}

                  <Card.Body key={index}>
                    {/* <Card.Title>Special title treatment</Card.Title> */}
                    {review?.tripInfos[index].sI.map((seg, id) => (
                      <>
                        <Card.Text
                          key={id}
                          style={{ marginTop: id == 1 && 20 }}
                        >
                          <Row>
                            <Col>
                              <Image
                                src={`/assets/images/airlineLogo/${seg?.fD.aI.code}.gif`}
                                //   src={`/assets/images/airline-logo/${seg?.fD.aI.code}.gif`}
                                alt={seg?.fD.aI.code}
                                height="35"
                                width={"35"}
                                style={{ borderRadius: 15 }}
                              />
                              <div>
                                {`${seg.fD.aI.name} ${seg?.fD.aI.code} ${seg?.fD.fN}`}{" "}
                              </div>
                            </Col>
                            <Col>
                              <div style={{ fontWeight: "bold", fontSize: 12 }}>
                                {moment(seg?.dt).format(
                                  "ddd, MMM Do, YYYY, hh:mm a"
                                )}
                              </div>

                              <div>
                                {seg?.da?.city} ({seg?.da?.code}),{" "}
                                {seg?.da?.country}
                              </div>
                              <div>
                                {seg?.da?.name.length >= 18 ? (
                                  <Tooltip
                                    placement="top"
                                    overlay={
                                      <div style={{ maxWidth: 250 }}>
                                        {seg?.da?.name}
                                      </div>
                                    }
                                  >
                                    <span style={{ cursor: "pointer" }}>
                                      {seg?.da?.name.substring(0, 18) + "..."}
                                    </span>
                                  </Tooltip>
                                ) : (
                                  seg?.da?.name
                                )}
                              </div>
                              <div>{seg?.da?.terminal}</div>
                            </Col>
                            <Col style={{ marginLeft: 35 }}>
                              <div style={{ marginTop: 20 }}>
                                <FaPlaneDeparture
                                  size={15}
                                  className="text-primary"
                                />
                                .............
                                <MdOutlineLocationOn
                                  size={15}
                                  className="text-primary"
                                />
                                .............
                                <FaPlaneArrival
                                  size={15}
                                  className="text-primary"
                                />
                              </div>
                            </Col>

                            <Col>
                              <div style={{ fontWeight: "bold", fontSize: 12 }}>
                                {moment(seg?.at).format(
                                  "ddd, MMM Do, YYYY, hh:mm a"
                                )}
                              </div>
                              <div>
                                {seg?.aa?.city} ({seg?.aa?.code}),{" "}
                                {seg?.aa?.country}
                              </div>
                              <div>
                                {seg?.aa?.name.length >= 18 ? (
                                  <Tooltip
                                    placement="top"
                                    overlay={
                                      <div style={{ maxWidth: 250 }}>
                                        {seg?.aa?.name}
                                      </div>
                                    }
                                  >
                                    <span style={{ cursor: "pointer" }}>
                                      {seg?.aa?.name.substring(0, 18) + "..."}
                                    </span>
                                  </Tooltip>
                                ) : (
                                  seg?.aa?.name
                                )}
                              </div>
                              <div>{seg?.aa?.terminal}</div>
                            </Col>

                            <Col>
                              <div style={{ fontWeight: "bold" }}>
                                {getTimeDiffFromDate(seg?.dt, seg?.at)}{" "}
                              </div>
                              <div>
                                {res?.totalPriceList[0]?.fd?.ADULT.cc} |{" "}
                                {res?.totalPriceList[0]?.fd?.ADULT.rT == 1
                                  ? "Refundable"
                                  : res?.totalPriceList[0]?.fd?.ADULT.rT == 0
                                  ? "Non Refundable"
                                  : "Partial Refundable"}
                                {res?.totalPriceList[0]?.fd?.ADULT.mI == true &&
                                  " | Free Meal"}
                              </div>
                            </Col>
                          </Row>
                        </Card.Text>
                        <Row>
                          {seg?.cT != null && seg?.cT != 0 && (
                            <div>
                              <div>
                                <div
                                  style={{
                                    width: "39%",
                                    float: "left",
                                    marginTop: "11px",
                                  }}
                                >
                                  <div
                                    style={{ borderBottom: "1px solid teal" }}
                                  ></div>
                                </div>
                                <div
                                  className="bg-primary"
                                  style={{
                                    width: "20%",
                                    float: "left",
                                    textAlign: "center",
                                    //   backgroundColor: "rgb(161, 11, 56)",
                                    borderRadius: "10px",
                                    marginLeft: "5px",
                                    marginRight: "5px",
                                    color: "white",
                                    fontWeight: "700",
                                  }}
                                >
                                  Layover Time - {convertIntoHr(seg?.cT)}
                                </div>
                                <div
                                  style={{
                                    width: "40%",
                                    float: "left",
                                    marginTop: "11px",
                                  }}
                                >
                                  <div
                                    style={{ borderBottom: "1px solid teal" }}
                                  ></div>
                                </div>
                              </div>
                            </div>
                          )}
                        </Row>
                      </>
                    ))}
                  </Card.Body>
                </Card>
              </>
            ))}
          </div>

          <Formik
            initialValues={formState}
            validationSchema={validationModel}
            enableReinitialize={true}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <form
                  className="needs-validation"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <table className="table table-striped">
                    <thead className="bg-primary text-white  ">
                      <tr style={{ textAlign: "center", fontSize: 12 }}>
                        <th scope="col">Fare Type</th>
                        <th scope="col">Booking Id</th>
                        <th scope="col">Booking Status</th>
                        <th scope="col">PNR</th>
                        <th scope="col">Refund Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ textAlign: "center" }}>
                        <td>
                          <div
                            className="text-primary"
                            style={{
                              marginTop: 26,
                              fontWeight: "bold",
                              textTransform: "uppercase",
                            }}
                          >
                            {fareType?.fareIdentifier}
                          </div>
                        </td>
                        <td>
                          <RenderTextInput
                            type="text"
                            name="bookingId"
                            // display="Booking Id"
                            placeholder="Booking Id"
                            value={values.bookingId || ""}
                            error={errors.bookingId || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.bookingId || false}
                          />
                        </td>

                        <td>
                          <RenderSelectInput
                            name="bookingStatus"
                            // display="Booking Status"
                            placeholder="Booking Status"
                            value={values.bookingStatus}
                            error={errors.bookingStatus}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.bookingStatus}
                            items={statusTypeOptions}
                          ></RenderSelectInput>
                        </td>
                        <td>
                          <RenderTextInput
                            type="text"
                            name="pnr"
                            // display="PNR"
                            placeholder="PNR"
                            value={values.pnr || ""}
                            error={errors.pnr || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.pnr || false}
                          />
                        </td>
                        <td>
                          <RenderSelectInput
                            name="refundStatus"
                            // display="Booking Status"
                            placeholder="Booking Status"
                            value={values.refundStatus || ""}
                            error={errors.refundStatus || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.refundStatus || false}
                            items={refundOptions}
                          ></RenderSelectInput>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table className="table table-striped">
                    <thead className="bg-primary text-white  ">
                      <tr style={{ textAlign: "center", fontSize: 12 }}>
                        <th scope="col">Total Base Fare</th>
                        <th scope="col">Total Tax Fare</th>

                        <th scope="col">SSR Amount</th>
                        <th scope="col">User markup</th>
                        <th scope="col">Total Fare</th>
                        <th scope="col">Commission</th>
                        <th scope="col">TDS</th>
                        <th scope="col">Total Net Fare</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ textAlign: "center" }}>
                        <td>
                          <RenderTextInput
                            type="text"
                            name="totalBF"
                            // display="Booking Id"
                            placeholder="Total Base Fare"
                            value={values.totalBF || ""}
                            error={errors.totalBF || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.totalBF || false}
                          />
                        </td>

                        <td>
                          <RenderTextInput
                            type="text"
                            name="totalTAF"
                            // display="PNR"
                            placeholder="Total Tax Fare"
                            value={values.totalTAF || ""}
                            error={errors.totalTAF || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.totalTAF || false}
                          />
                        </td>
                        <td>
                          <RenderTextInput
                            readOnly
                            value={ssrOnward}
                          ></RenderTextInput>
                        </td>
                        <td>
                          <RenderTextInput
                            readOnly
                            value={userMarkup}
                          ></RenderTextInput>
                        </td>
                        <td>
                          <RenderTextInput
                            readOnly
                            name="totalTF"
                            // display="Booking Status"
                            placeholder="Total Fare"
                            value={values.totalTF}
                            error={errors.totalTF}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.totalTF}
                          ></RenderTextInput>
                        </td>
                        <td>
                          <RenderTextInput
                            readOnly
                            value={airlinesMarkupComOnward}
                          ></RenderTextInput>
                        </td>
                        <td>
                          <RenderTextInput
                            readOnly
                            value={tdsOnward}
                          ></RenderTextInput>
                        </td>
                        <td>
                          <RenderTextInput
                            readOnly
                            name="totalNF"
                            // display="Booking Status"
                            placeholder="Total Net Fare"
                            value={values.totalNF || ""}
                            error={errors.totalNF || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.totalNF || false}
                          ></RenderTextInput>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <Row
                    className="text-white p-2 text-15 bg-primary"
                    style={{
                      fontWeight: "700",
                      marginLeft: 1,
                      marginRight: 1,
                    }}
                  >
                    Passenger Details
                  </Row>

                  {values.travellerInfo &&
                    values.travellerInfo.map((traveller, index) => (
                      <div key={index}>
                        {/* {JSON.stringify(values)} */}

                        <div
                          style={{
                            border: `1px solid ${"#d2c2e3"}`,
                            marginBottom: 5,
                            boxShadow: 10,
                            marginTop: 2,
                          }}
                        >
                          <Row
                            className="text-black p-1 text-12  mb-2 "
                            style={{
                              marginLeft: 1,
                              marginRight: 1,
                              // fontWeight: "700",
                              backgroundColor: "#cda5f7",
                            }}
                          >
                            {`Passenger- ${index + 1}`} (
                            {traveller?.pt == "Adult" && "Adult"}
                            {traveller?.pt == "Child" && "Child"}
                            {traveller?.pt == "Infant" && "Infant"})
                          </Row>

                          <div className="row p-1">
                            <RenderTextInput
                              type="text"
                              name={`travellerInfo[${index}].passengerId`}
                              display={`Passenger Id`}
                              placeholder={`Passenger Id`}
                              value={traveller.id || ""}
                              error={
                                (errors.travellerInfo &&
                                  errors.travellerInfo[index]?.passengerId) ||
                                ""
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={
                                (touched.travellerInfo &&
                                  touched.travellerInfo[index]?.passengerId) ||
                                false
                              }
                              hidden
                            />
                            <RenderSelectInput
                              type="text"
                              name={`travellerInfo[${index}].ti`}
                              display={`Title`}
                              placeholder={`Title`}
                              value={traveller.ti || ""}
                              error={
                                (errors.travellerInfo &&
                                  errors.travellerInfo[index]?.ti) ||
                                ""
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={
                                (touched.travellerInfo &&
                                  touched.travellerInfo[index]?.ti) ||
                                false
                              }
                              items={titleOptions}
                            />
                            <RenderTextInput
                              type="text"
                              name={`travellerInfo[${index}].fN`}
                              display={`First Name`}
                              placeholder={`First Name`}
                              value={values.travellerInfo[index]?.fN || ""}
                              error={
                                (errors.travellerInfo &&
                                  errors.travellerInfo[index]?.fN) ||
                                ""
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={
                                (touched.travellerInfo &&
                                  touched.travellerInfo[index]?.fN) ||
                                false
                              }
                              required
                            />
                            <RenderTextInput
                              type="text"
                              name={`travellerInfo[${index}].lN`}
                              display={`Last Name`}
                              placeholder={`Last Name`}
                              value={values.travellerInfo[index]?.lN || ""}
                              error={
                                (errors.travellerInfo &&
                                  errors.travellerInfo[index]?.lN) ||
                                ""
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={
                                (touched.travellerInfo &&
                                  touched.travellerInfo[index]?.lN) ||
                                false
                              }
                              required
                            />

                            {traveller.dob.length > 0 && (
                              <RenderTextInput
                                type="date"
                                name={`travellerInfo[${index}].dob`}
                                display={`Date of Birth`}
                                placeholder={`Date of Birth`}
                                value={values.travellerInfo[index]?.dob || ""}
                                error={
                                  (errors.travellerInfo &&
                                    errors.travellerInfo[index]?.dob) ||
                                  ""
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                touched={
                                  (touched.travellerInfo &&
                                    touched.travellerInfo[index]?.dob) ||
                                  false
                                }
                                required
                              />
                            )}
                          </div>
                          <div className="row p-1">
                            <RenderSelectInput
                              name={`travellerInfo[${index}].pt`}
                              display={`Passenger Type`}
                              placeholder={`Passenger Type`}
                              value={values.travellerInfo[index].pt || ""}
                              error={
                                (errors.travellerInfo &&
                                  errors.travellerInfo[index].pt) ||
                                ""
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={
                                (touched.travellerInfo &&
                                  touched.travellerInfo[index]?.pt) ||
                                false
                              }
                              items={paxTypeOptions}
                              required
                            ></RenderSelectInput>
                            <RenderTextInput
                              type="text"
                              name={`travellerInfo[${index}].passengerPnr`}
                              display={`PNR`}
                              placeholder={`PNR`}
                              value={
                                values.travellerInfo[index]?.passengerPnr || ""
                              }
                              error={
                                (errors.travellerInfo &&
                                  errors.travellerInfo[index]?.passengerPnr) ||
                                ""
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={
                                (touched.travellerInfo &&
                                  touched.travellerInfo[index]?.passengerPnr) ||
                                false
                              }
                              required
                            />

                            <RenderTextInput
                              type="text"
                              name={`travellerInfo[${index}].ticketNo`}
                              display={`Ticket Number`}
                              placeholder={`Ticket Number`}
                              value={
                                values?.travellerInfo[index]?.ticketNo || ""
                              }
                              error={
                                (errors.travellerInfo &&
                                  errors.travellerInfo[index]?.ticketNo) ||
                                ""
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={
                                (touched.travellerInfo &&
                                  touched.travellerInfo[index]?.ticketNo) ||
                                false
                              }
                              // required
                            />
                            <RenderTextInput
                              type="text"
                              name={`travellerInfo[${index}].gdsPnrs`}
                              display={`GDS PNR`}
                              placeholder={`GDS PNR`}
                              value={
                                values?.travellerInfo[index]?.gdsPnrs || ""
                              }
                              error={
                                (errors.travellerInfo &&
                                  errors.travellerInfo[index]?.gdsPnrs) ||
                                ""
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={
                                (touched.travellerInfo &&
                                  touched.travellerInfo[index]?.gdsPnrs) ||
                                false
                              }
                              // required
                            />
                            {/* <RenderSelectInput
                                // name={`travellerInfo[${index}].ticketNo`}
                                display={`Refund Option`}
                                placeholder={`Refund Option`}
                                // value={values.travellerInfo[index].ticketNo || ""}
                                // error={
                                //   (errors.travellerInfo &&
                                //     errors.travellerInfo[index].ticketNo) ||
                                //   ""
                                // }
                                // onChange={handleChange}
                                // onBlur={handleBlur}
                                // touched={
                                //   (touched.travellerInfo &&
                                //     touched.travellerInfo[index]?.ticketNo) ||
                                //   false
                                // }
                                // required
                                items={refundOptions}
                              /> */}
                          </div>

                          {traveller.isDomestic == false && (
                            <Row className="p-1">
                              <Col>
                                <RenderTextInput
                                  type="text"
                                  name={`travellerInfo[${index}].pNum`}
                                  display={`Passport Number`}
                                  placeholder={`Passport Number`}
                                  value={values.travellerInfo[index]?.pNum}
                                  error={
                                    (errors.travellerInfo &&
                                      errors.travellerInfo[index]?.pNum) ||
                                    ""
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  touched={
                                    (touched.travellerInfo &&
                                      touched.travellerInfo[index]?.pNum) ||
                                    false
                                  }
                                  required
                                />
                              </Col>
                              <Col>
                                <RenderTextInput
                                  type="date"
                                  name={`travellerInfo[${index}].pid`}
                                  display={`Passport Issue Date`}
                                  placeholder={`Passport Issue Date`}
                                  value={
                                    moment(
                                      values.travellerInfo[index]?.pid
                                    ).format("YYYY-MM-DD") || ""
                                  }
                                  error={
                                    (errors.travellerInfo &&
                                      errors.travellerInfo[index]?.pid) ||
                                    ""
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  touched={
                                    (touched.travellerInfo &&
                                      touched.travellerInfo[index]?.pid) ||
                                    false
                                  }
                                  required
                                />
                              </Col>
                              <Col>
                                <RenderTextInput
                                  type="date"
                                  name={`travellerInfo[${index}].eD`}
                                  display={`Passport Expiry Date`}
                                  placeholder={`Passport Expiry Date`}
                                  value={
                                    moment(
                                      values.travellerInfo[index]?.eD
                                    ).format("YYYY-MM-DD") || ""
                                  }
                                  error={
                                    (errors.travellerInfo &&
                                      errors.travellerInfo[index]?.eD) ||
                                    ""
                                  }
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  touched={
                                    (touched.travellerInfo &&
                                      touched.travellerInfo[index]?.eD) ||
                                    false
                                  }
                                  required
                                />
                              </Col>
                              <Col>
                                <label>
                                  Passport Nationality{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-control"
                                  name={`travellerInfo[${index}].pNat`}
                                  value={
                                    values.travellerInfo[index]?.pNat || ""
                                  }
                                  onChange={(e) => {
                                    setFieldValue(
                                      `travellerInfo[${index}].pNat`,
                                      e.target.value
                                    );
                                    const countryName = country.filter(
                                      (item) => item.code == e.target.value
                                    );
                                    // setFieldValue(
                                    //   `travellerInfo[${index}].pNat`,
                                    //   countryName.length > 0
                                    //     ? countryName[0].name
                                    //     : ""
                                    // );
                                  }}
                                  onBlur={handleBlur}
                                  // display={"none"}
                                >
                                  {country?.map((h, i) => (
                                    <option key={i} value={h.name}>
                                      {h.name} - {h.code}
                                    </option>
                                  ))}
                                </select>
                              </Col>
                            </Row>
                          )}
                        </div>
                      </div>
                    ))}

                  <Row>
                    <RenderTextArea
                      display={`Remarks`}
                      name={"remarks"}
                      placeholder={`Remarks`}
                      value={values.remarks || ""}
                      error={errors.remarks || ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.remarks || false}
                    />
                  </Row>
                  <div className=" d-flex justify-content-center">
                    <Button
                      type="submit"
                      variant="primary"
                      className="mt-3"
                      // onClick={handleSubmit}
                    >
                      Update
                    </Button>
                  </div>
                </form>
              );
            }}
          </Formik>
        </>
      </Modal.Body>
    </Modal>
  );
};

export default memo(PnrAlert);
